import { getCookie, apiVersion } from "./api";

// The upload endpoints may return different shapes depending on context:
// - Single file: { url, order? } or { photo: { url, order? } }
// - Multi-file (map): { [filename]: { url, order? }, ... }
// Keep the response type permissive to avoid index-signature conflicts.
export type UploadImageResponse = {
  url?: string;
  order?: number;
  photo?: { url: string; order?: number };
  [key: string]: any;
};

export async function uploadImage(
  file: File,
  endpoint: "thumb" | "spot" | "property"
): Promise<UploadImageResponse> {
  const formData = new FormData();
  formData.append("file", file);

  const apiBase = String((import.meta as any).env?.VITE_API ?? "");
  const base = apiBase.endsWith("/") ? apiBase : `${apiBase}/`;
  const url = `${base}admin/${apiVersion}/image/${endpoint}`;
  const token = getCookie("accessToken");
  const headers = token ? { Authorization: `Bearer ${token}` } : undefined;

  const response = await fetch(url, {
    method: "POST",
    body: formData,
    headers,
    credentials: "include",
  });

  if (!response.ok) {
    const text = await response.text().catch(() => "");
    throw new Error(
      `Upload failed: ${response.status} ${response.statusText}${
        text ? ` - ${text}` : ""
      }`
    );
  }

  return await response.json();
}

export function getPhotoUrl(data: UploadImageResponse): string {
  if (data?.url) {
    return data.url;
  } else if (data?.photo?.url) {
    return data.photo.url;
  } else if (data) {
    const firstKey = Object.keys(data)[0];
    if (data[firstKey]?.url) {
      return data[firstKey].url;
    }
  }
  return "";
}
